import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { GroupListScreen } from 'screens/group';

export default withPermissions(GroupListScreen, [GroupSecurity.GroupRead]);
